import React from "react";
import Routes from "./Routes";
import { GlobalLoadingProvider } from "./context/GlobalLoadingContext";
import { GlobalSettingProvider } from "context/GlobalSettingContext";

function App() {
  return (
    <GlobalSettingProvider>
      <GlobalLoadingProvider>
        <Routes />
      </GlobalLoadingProvider>
    </GlobalSettingProvider>
  );
}

export default App;
